import { TestContext, ValidationError } from "yup";

import { TimeZoneEnum } from "../enums";

export type IValidationYupType =
  "object" | "string" | "number" | "array" | "mixed" | "bool" | "date";

export type TValidationYup =
  | "required"
  | "min"
  | "max"
  | "integer"
  | "email"
  | "nullable"
  | "notRequired"
  | "matches"
  | "custom";

export enum CustomValidate {
  NOT_BIGGER_TIME_THAN_SIBLING = "NOT_BIGGER_TIME_THAN_SIBLING",
  NOT_LOWER_TIME_THAN_SIBLING = "NOT_LOWER_TIME_THAN_SIBLING",
  ONE_OF_TWO_FIELDS_IS_REQUIRED = "ONE_OF_TWO_FIELDS_IS_REQUIRED",
  ADDITIONS_VALUE_IS_REQUIRED = "ADDITIONS_VALUE_IS_REQUIRED",
  EXCLUSIVE_PRICE_ADDITION = "EXCLUSIVE_PRICE_ADDITION",
  BOOKING_PASSENGER_CELL_INFO_MAX_ROWS = "BOOKING_PASSENGER_CELL_INFO_MAX_ROWS",
  NOT_IN_THE_PAST = "NOT_IN_THE_PAST",
}

export const siblingRequiredCustomValidation = new Set([
  CustomValidate.NOT_BIGGER_TIME_THAN_SIBLING,
  CustomValidate.NOT_LOWER_TIME_THAN_SIBLING,
]);

export type TValidationYupUnitMatchesParams = [
  regexParam: string,
  message: string,
];

export interface IValidationYupUnitSiblingParams {
  ref: string;
}

export type TValidationYupUnitParams =
  | ICustomValidationParams
  | IValidationYupUnitSiblingParams
  | TValidationYupUnitMatchesParams
  | number
  | string
  | boolean;

export interface IValidationsYupRoot {
  type: IValidationYupType;
  rules: IValidationYupUnit[];
}

export interface IValidationYupUnit {
  validation: TValidationYup;
  params?: TValidationYupUnitParams[];
}

export interface IValidationYupConfig {
  fieldName: string;
  rules?: IValidationYupUnit[];
  validationType: IValidationYupType;
}

export interface IValidationParams {
  value?: number | string | boolean;
  message?: string;
}

export type IValidationType =
  "required" | "min" | "max" | "maxLength" | "minLength" | "pattern";

export interface ICustomValidationAdditional {
  siblingName?: string;
  num1?: string;
  num2?: string;
}

export interface ICustomValidationParams {
  customValidationName: CustomValidate;
  customValidationErrorMessage: string;
  customValidationAdditional?: ICustomValidationAdditional;
}

export interface ITestResolverParams {
  value: unknown;
  context: TestContext;
  errorMessage: string;
  validationAdditional: ICustomValidationAdditional;
  /** Company timezone. Date rules must resolve "today" in the company's zone, not the viewer's. */
  timezone?: TimeZoneEnum;
}

export type TestResolver = (
  options: ITestResolverParams,
) => boolean | ValidationError;
